<!--一周排班的参照-->
<template>
  <div class="table-container" style="margin-top: 0px;">
    <el-table
      :key="refreshTimer"
      :data="tableData"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      border>
      <el-table-column :label="tableTitleData.position" prop="position"></el-table-column>
      <el-table-column :label="tableTitleData.swTeacher" prop="name"></el-table-column>
      <el-table-column v-for="(titleItem,idx) in tableTitleData.time" v-bind:key="idx" :label="titleItem">
        <template slot-scope="scope">
          <el-row >
            <el-col span="7" style="margin-left: 50px">
              <div v-if="scope.row.checked[idx][0]" >
                <el-button type="success" size="mini" icon="el-icon-check" circle @click = "checkClick(scope.$index, idx,0)">A</el-button>
              </div>
              <div v-else >
                <el-button  circle size="mini" @click = "checkClick(scope.$index, idx,0)">A</el-button>
              </div>
            </el-col>
            <el-col span="7">
              <div v-if="scope.row.checked[idx][1]" >
                <el-button type="success" size="mini"  icon="el-icon-check" circle @click = "checkClick(scope.$index, idx,1)">B</el-button>
              </div>
              <div v-else >
                <el-button  circle size="mini" @click = "checkClick(scope.$index, idx,1)">B</el-button>
              </div>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>


  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import timeUtils from "../../../utils/timeUtils";
  import {qlDayReleaseLessons} from "../../../api/StoreReleaseLesson";
  import enumsUtil from "../../../utils/enumsUtil";

  export default {
    name: 'ScheReference',
    components: {},
    props: {

      times:Array , //一周的排班的员工id

    },
    data() {
      return {
        tableTitleData:{
          position:"职位",
          swTeacher:"泳师",
          time:['周一','周二','周三','周四','周五','周六','周日'],
        },
        tableData:[],
        allWorker:[],
        storeWorkerPositions:[],//职位
        refreshTimer:null,
      }
    },
    created() {

      this.initData();
    },
    methods: {
      initData() {
        globaldata.getStorePosition(this.getStorePosition);

      },
      getStoreWorkersInfo(workers){

        this.tableData = [];
        this.allWorker = workers;
        this.resetWorkerSche();
        this.refreshData(this.times)

      },
      getStorePosition(data){
        this.storeWorkerPositions = data;
        globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);

      },
      //重置所有人排班
      resetWorkerSche(){
        //先将所有的都置为没有排班
        this.tableData = [];
        for (let i = 0;i< this.allWorker.length;++i){
          let worker = {
            id :this.allWorker[i].id,
            name :this.allWorker[i].name,
            position:this.allWorker[i].position,
            power:this.getPositionPower(this.allWorker[i].position),
            checked :[[false,false],[false,false],[false,false],[false,false],[false,false],[false,false],[false,false]]
          }
          this.tableData.push(worker);
        }
        this.tableData.sort(function(a,b){
          return a.power-b.power});
      },
      getPositionPower(positions){
        for (let i = 0;i<this.storeWorkerPositions.length;++i){
          if (this.storeWorkerPositions[i].positions == positions){
            return this.storeWorkerPositions[i].power;
          }
        }
        return 99999;
      },

      checkClick(index,checkIndex,ap){
        let check  = this.tableData[index].checked[checkIndex][ap];
        this.tableData[index].checked[checkIndex][ap] = (!check);
        this.refreshTimer = new Date().getTime();
      },

      refreshData(times){

        if (commonUtils.isArrayNull(times)){
          return;
        }
        this.resetWorkerSche();

        for (let i = 0;i< times.length;++i){
          let dayIndex  = times[i].dayIndex;
          let workersAm  =  times[i].workers.am;
          if (!commonUtils.isObjectNull(workersAm)){
            for (let j = 0;j< workersAm.length;++j){
              let tableWorker = this.getTableDataWorker(workersAm[j]);
              if (!commonUtils.isObjectNull(tableWorker)){
                tableWorker.checked[dayIndex][0] = true;
              }
            }
          }
          let workersPm  =  times[i].workers.pm;
          if (!commonUtils.isObjectNull(workersPm)){
            for (let j = 0;j< workersPm.length;++j){
              let tableWorker= this.getTableDataWorker(workersPm[j]);
              if (!commonUtils.isObjectNull(tableWorker)){
                tableWorker.checked[dayIndex][1] = true;
              }
            }
          }

        }

      },
      getTableDataWorker(id){
        for (let i =0;i< this.tableData.length;++i ){
          if (this.tableData[i].id == id){
            return this.tableData[i];
          }
        }
      },

      getScheTimes(){
        //计算每周哪些人上班
        let weekData = [];
        for (let dayIndex  =0;dayIndex< this.tableTitleData.time.length;++dayIndex) {
          //dayIndex 周几
          let weekItem = {
            dayIndex:dayIndex,
            workers :[]
          }
          let workerStr = {
            am:[],
            pm:[]
          };
          for (let i = 0;i< this.tableData.length;++i){
            let worker = this.tableData[i];
            if (worker.checked[dayIndex][0] == true){
              workerStr.am.push(worker.id);
            }
            if (worker.checked[dayIndex][1] == true){
              workerStr.pm.push(worker.id);
            }
          }
          weekItem.workers = workerStr;
          weekData.push(weekItem);
        }
        return weekData;
      },



    }
  }

</script>






// WEBPACK FOOTER //
// src/views/my-store/component/ScheReference.vue